// extracted by mini-css-extract-plugin
export var content = "_nu-1";
export var fullScreen = "_nu-0";